<template>
  <div>
    <b-row>
      <b-col sm="12" @click="selectPage">
        <img style="width: 100%; border-color: #20a8d8; border-width: thick;" :style="{'border-style': (isSelected ? 'solid' : 'none')}" :src="page.thumbnail"/>
      </b-col>
      <b-col sm="12" style="margin-top: 5px;">
        <b-button variant="primary" @click="moveToLeft">
          <span><i class="fa fa-arrow-left"></i></span>
        </b-button>
        <b-button variant="primary" @click="moveToRight">
          <span><i class="fa fa-arrow-right"></i></span>
        </b-button>
      </b-col>
      <b-col sm="12" style="margin-top: 5px;">
        <b-button variant="primary" @click="duplicate">
          <span><i class="fa fa-files-o"></i></span>
        </b-button>
        <b-button variant="warning" @click="remove">
          <span><i class="fa fa-trash"></i></span>
        </b-button>
      </b-col>
      <!--<b-col sm="12" style="margin-top: 5px;" class="text-center">
        <b-row>
          <b-col cols="12">
            <b-form-input v-model="number" type="text"></b-form-input>
          </b-col>
        </b-row>
      </b-col>-->
    </b-row>

    <!--<div :id="'gjs' + order"></div>-->
  </div>
</template>

<script>
import grapes from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import pt from "grapesjs/locale/pt";

export default {
  name: "DocPage",
  props: {
    page: null,
    order: 0,
    isSelected: false
  },
  data: function () {
    return {
      editor: null
    };
  },

  mounted() {
    return;
    this.editor = grapes.init({
      container: ("#gjs" + this.order),
      i18n: {
        locale: "pt", // default locale
        localeFallback: "pt", // default fallback
        messages: { pt, pt },
      },
      // storageManager: { type: 'none' },
      //plugins: ["gjs-preset-webpage", "gjs-plugin-export"],
      plugins: ["gjs-plugin-export"],
      width: "110px",
      height: "140px",
      pluginsOpts: {
        "gjs-preset-webpage": {
          textCleanCanvas: "Você tem certeza que deseja limpar?",
        },
      },
      canvas: {
        styles: ["https://cdn.jsdelivr.net/npm/vuetify/dist/vuetify.min.css"],
      },
      storageManager: {
        id: "gjs-", // Prefix identifier that will be used on parameters
        type: "local", // Type of the storage
        autosave: false, // Store data automatically
        autoload: false, // Autoload stored data on init
        stepsBeforeSave: 1, // If autosave enabled, indicates how many changes are necessary before store method is triggered
      },
      panels: { defaults: [] },
      styleManager: {
        appendTo: document.createElement('divaaa'),
      }
    });

    if (!this.page.html) {
      fetch(this.page.url).then(result => {
        result.text().then((textResult) => {
          this.editor.setComponents(textResult);
        })
      });
    } else {
      this.editor.setComponents(this.page.html);
      
      if (this.page.css) {
        this.editor.setStyle(this.page.css);
      }

      const allComponents = this.getAllComponents(this.editor.DomComponents.getWrapper());
      for (let key in allComponents) {
        allComponents[key].set({draggable: false, selectable: false, hoverable: false});
      }
    }
  },
  methods: {
    getAllComponents(model, result = []) {
      result.push(model);
      model.components().each(mod => this.getAllComponents(mod, result))
      return result;
    },
    remove() {
      this.$emit("remove");
    },
    duplicate() {
      this.$emit("duplicate");
    },
    moveToRight() {
      this.$emit("moveToRight");
    },
    moveToLeft() {
      this.$emit("moveToLeft");
    },
    selectPage() {
      this.$emit("selectPage");
    }
  },
  created: function () {
   
  },
};
</script>

<style scoped>
  .gjs-one-bg, .gjs-two-color {
    background: transparent !important;
  }

  .gjs-frame {
    position: absolute;
    left: -2000px;
    top: -2500px;
  }
</style>